var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrackRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99999 19.5999C15.3019 19.5999 19.6 15.3018 19.6 9.9999C19.6 4.69797 15.3019 0.399902 9.99999 0.399902C4.69806 0.399902 0.399994 4.69797 0.399994 9.9999C0.399994 15.3018 4.69806 19.5999 9.99999 19.5999ZM14.4485 8.44843C14.9171 7.9798 14.9171 7.22 14.4485 6.75137C13.9799 6.28275 13.2201 6.28275 12.7515 6.75137L8.79999 10.7028L7.24852 9.15137C6.77989 8.68274 6.02009 8.68274 5.55146 9.15137C5.08284 9.62 5.08284 10.3798 5.55146 10.8484L7.95146 13.2484C8.42009 13.7171 9.17989 13.7171 9.64852 13.2484L14.4485 8.44843Z",
    fill: "#7DB300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackRightIcon);
export default __webpack_public_path__ + "static/media/track_right_icon.49407df7ec8dcc2642b60535901d5c6e.svg";
export { ForwardRef as ReactComponent };